import styled from 'styled-components';

export const RiskEvaluationTitle = styled.p`
	font-size: ${({ theme }) => theme.sizes.fonts.fs_md};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_md};
	letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_lg};
	font-weight: ${({ theme }) => theme.sizes.weights.semibold};
	margin-bottom: 16px;
`;

export const RiskLevel = styled.span`
	font-size: ${({ theme }) => theme.sizes.fonts.fs_xs};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_xs};
	letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_lg};
	font-weight: ${({ theme }) => theme.sizes.weights.semibold};
	text-align: center;
`;

export const ObservationText = styled.p`
	font-size: ${({ theme }) => theme.sizes.fonts.fs_xs};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_xs};
	letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_md};
	font-weight: ${({ theme }) => theme.sizes.weights.regular};
	color: ${({ theme }) => theme.palette.secondary[400]};
	margin-top: 12px;
	text-align: start;
`;

export const RiskEvaluationTable = styled.table`
	width: 100%;
	height: 64px;
	border-collapse: separate;
	border-spacing: 2px;
	margin-bottom: 20px;
	border-radius: 8px;
	overflow: hidden;
	table-layout: fixed;

	thead {
		background-color: ${({ theme }) => theme.palette.secondary[100]};

		th {
			padding: 16px;
			text-align: center;
			border-right: 1px solid white;
			width: 50%;

			font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
			line-height: ${({ theme }) => theme.sizes.line_heights.lh_md};
			letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_lg};
			font-weight: ${({ theme }) => theme.sizes.weights.semibold};

			&:last-child {
				border-right: none;
			}
		}
	}

	tbody {
		background-color: ${({ theme }) => theme.palette.secondary[50]};

		td {
			padding: 16px;
			border-right: 1px solid white;
			font-size: ${({ theme }) => theme.sizes.fonts.fs_xs};
			text-align: center;
			width: 50%;

			&:last-child {
				border-right: none;
			}
		}
	}
`;

export const ObservationsSection = styled.div`
	width: 100%;
	padding: 16px;
	border-radius: 8px;
	background-color: ${({ theme }) => theme.palette.secondary.white};

	h4 {
		background-color: ${({ theme }) => theme.palette.secondary[100]};
		margin: -16px -16px 0 -16px;
		padding: 12px 16px;
		border-bottom: 1px solid ${({ theme }) => theme.palette.secondary.white};
		border-radius: 8px 8px 0 0;
	}
`;
